import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, ContractInfo, inject, ServicesAlert, StatusCard, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { ContractsStore } from '../../../Contracts/ContractsStore';
import { ActiveDisplay } from '../../ActiveDisplay';

export interface IDisplayContractCardProps {
    readonly loading?: boolean;
    readonly display: ActiveDisplay;
}

@autoinject
@observer
export class DisplayContractCard extends React.Component<IDisplayContractCardProps> {
    public render() {
        return (
            <StatusCard title={this.renderTitle()} loading={this.props.loading}>
                <ContractInfo contract={this.contract} display={this.props.display} />
            </StatusCard>
        );
    }

    @bind
    private renderTitle() {
        return (
            <div>
                Contract: {this.contract?.serviceCO}
                <ServicesAlert
                    className="float-end px-2"
                    type="message"
                    contract={this.contract}
                    display={this.props.display}
                />
            </div>
        );
    }

    @computed
    private get contract() {
        if (this.props.display.contract) return this.contractsStore.contracts.get(this.props.display.contract);
    }

    @inject
    private contractsStore!: ContractsStore;
}
